import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// @atlaskit
import Avatar from '@atlaskit/avatar';
import Modal from '@atlaskit/modal-dialog';
import Spinner from '@atlaskit/spinner';
import Tag from '@atlaskit/tag';

// @source
import { crypto } from '../../../../utils';
import { Messages } from '../../../components';
import { User as API } from '../../../../server';
import ErrorModal from './ErrorModal';

const initialState = {
  isLoading: false,
  message: false,
};

class DeleteUser extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
    this.unmount = false;
    this.uuid = crypto.decode(this.props.uuid);
    this.onSubmitHandle = this.onSubmitHandle.bind(this);
  }

  componentWillUnmount() {
    this.unmount = true;
  }

  onSubmitHandle(event) {
    event.preventDefault();

    this.setState({
      isLoading: true,
      message: false,
    });

    API.remove({
      data: [{ username: this.uuid }],
      dispatch: this.props.dispatch,
      success: () => {
        this.props.onClose();
      },
      error: (messages) => {
        this.setStateUnmount({
          isLoading: false,
          message: (
            <Messages
              component="Modal"
              items={messages}
              onClose={() => this.setState({ message: false })}
            />
          ),
        });
      },
    });
  }

  setStateUnmount(state) {
    if (this.unmount) return;
    this.setState(state);
  }

  render() {
    this.user = this.props.users.data.find(item => item.Username === this.uuid);

    if (this.props.users.override && !this.user) {
      return <ErrorModal onClose={this.props.onClose} />;
    }

    return (
      <Modal
        appearance="warning"
        heading="Delete account"
        onClose={this.props.onClose}
        width="small"
        actions={[{
          appearance: 'primary',
          isLoading: this.state.isLoading,
          isDisabled: !this.props.users.override,
          onClick: this.onSubmitHandle,
          text: 'Delete user',
          type: 'submit',
        }, {
          appearance: 'subtle',
          onClick: this.props.onClose,
          text: 'Cancel',
        }]}
      >
        {this.props.users.override
          ? (
            <div style={{ paddingLeft: 34 }}>
              <p>Are you sure you want to delete this account?</p>
              <div style={{ margin: '12px -4px 0' }}>
                <Tag
                  color="greyTag"
                  elemBefore={<Avatar size="xsmall" />}
                  text={this.uuid}
                />
              </div>
            </div>
          )
          : (
            <div style={{ padding: 18, textAlign: 'center' }}>
              <Spinner size="medium" />
            </div>
          )}
        {this.state.message}
      </Modal>
    );
  }
}

DeleteUser.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  users: PropTypes.shape().isRequired,
  uuid: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  users: state.User,
});

export default connect(mapStateToProps)(DeleteUser);
